import { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { RestApi } from 'common/services/rest-api.service';
import * as EmailValidator from 'email-validator';
import { Common } from 'common/services/common.service';
import { IJira, FIELDS } from '../config';
import { Paths } from 'common/constants/paths';
import { PathNames } from 'common/constants/pathNames';
import { useDispatch } from 'react-redux';
import { CustomSwitch } from 'common/components/CustomSwitch/CustomSwitch';
import { showSuccess, showError } from 'features/AlertSlice';
import { Collapse as MuiCollapse } from '@mui/material';
import classNames from 'classnames';
import useShowToggle from 'common/hooks/useShowToggle';
import { IconArrow } from 'common/components/Icons/IconArrow/IconArrow';

interface IJiraBlock {
  // name: string;
  integration: any;
  setValue: (key: string, value: any) => void;
  deleteIntegrationOnClick: (ev: any) => void;
  clickedSubmit: boolean;
  activeOnChange: (active: string, id: string) => void;
  error?: any;
}

const JiraBlock: React.FC<IJiraBlock> = ({
  integration,
  setValue,
  deleteIntegrationOnClick,
  clickedSubmit,
  activeOnChange
}) => {
  // const [isActive, setIsActive] = useState(false);
  const [isActive, setIsActive] = useState(integration.status === 'active');
  const { isOpen, toggle } = useShowToggle(true);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (!!integration) {
      setIsActive(integration.status === 'active');
    }
  }, [integration]);

  const onChange = (e: React.ChangeEvent, isChecked: boolean) => {
    setIsActive(isChecked);
    RestApi.setData(
      `${Paths[PathNames.integrationJira]}${integration.id}/`,
      { status: isChecked ? 'active' : 'inactive' },
      'PATCH'
    ).subscribe(
      (response: any) => {
        activeOnChange(isChecked ? 'active' : 'inactive', integration.id);
        dispatch(showSuccess(`Integration ${isChecked ? 'Activated' : 'Deactivated'} Successfully`));
      },
      error => {
        setIsActive(!isChecked);
        dispatch(showError('Something went wrong'));
      }
    );
  };

  const deleteBeforeApplyOnClick = (ev: any) => {
    deleteIntegrationOnClick(ev);
  };

  const checkIsValidation = (field: any) => {
    switch (field) {
      case 'configuration_name':
        return integration.configuration_name.length > 2;
      case 'server_url':
        return Common.validateURL(integration?.configuration.server_url);
      case 'username':
        return EmailValidator.validate(integration.configuration.username);
      case 'password':
        return integration.configuration.password.length > 2;
      case 'project':
        return integration.configuration.project.length > 1;
      default:
        return false;
    }
  };

  return (
    <div className="jira-group">
      <div className="jira-group-headline">
        <div style={{ position: 'relative', top: 2 }} onClick={toggle}>
          <IconArrow toggleRotate={isOpen} />
        </div>
        {/* <Collapse toggle={!isOpen} onClick={toggle} /> */}
        <h6 style={{ flexGrow: 1, paddingLeft: 8 }}>{integration.configuration_name}</h6>
        {/* <div className="devider" /> */}
        {!!integration.id && <CustomSwitch checked={isActive} onChange={onChange} />}
        <div className="delete-button-block" onClick={deleteBeforeApplyOnClick}>
          <img alt="delete integration" src="/assets/images/trash.svg" />
        </div>
      </div>

      <MuiCollapse in={isOpen} timeout="auto" unmountOnExit>
        <div className={classNames({ active: isActive }, { inActive: !isActive })}>
          {FIELDS.map((field: any) => {
            const key = field.field === 'configuration_name' ? integration : integration.configuration;
            const isError = !checkIsValidation(field.field);
            return (
              <div className="text-field-wrapper" key={field.label}>
                <TextField
                  fullWidth
                  label={field.label}
                  className="input"
                  value={key[field.field as keyof IJira]}
                  onChange={e => setValue(field.field, e.target.value)}
                  disabled={!!integration.id && !['username', 'password'].includes(field.field)}
                  type={field.isPassword ? 'password' : 'text'}
                  onFocus={(ev: any) => ev.target.select()}
                  sx={{ '& .Mui-error': { color: 'red' }, '& .MuiFormHelperText-root': { fontSize: 11 } }}
                  inputProps={{
                    autoComplete: 'new-password'
                  }}
                  // helperText="HELP"
                  // error={!!error && !!error[field.field]}
                  error={isError && clickedSubmit}
                  // helperText={isError && clickedSubmit ? field.errorText : ''}
                />
              </div>
            );
          })}
        </div>
      </MuiCollapse>
    </div>
  );
};

export default JiraBlock;
